import { Subject } from "rxjs";

const passAudioMediaAction = new Subject<any>();
const passEMSAudioMediaAction = new Subject<any>();
const passVideoMediaAction = new Subject<any>();
const passEMSVideoMediaAction = new Subject<any>();
const passImageMediaAction = new Subject<any>();
const passEMSImageMediaAction = new Subject<any>();
const passReplyMediaAction = new Subject<any>();
const passEKGMediaAction = new Subject<any>();
const passForwardMediaAction = new Subject<any>();
const passUnAuthorizedAction = new Subject<any>();
const passOnCallResultAction = new Subject<any>();
const passProfileUpdatedAction = new Subject<any>();
const updateCaseDetails = new Subject<any>();
const passToGetSchedules = new Subject<any>();
const passCalendarDateClick = new Subject<any>();
const passCalendarDateClear = new Subject<any>();
const passNotesListAction = new Subject<any>();
const passReminderListAction = new Subject<any>();
const passProviderListAction = new Subject<any>();
const passSmsListAction = new Subject<any>();
const passUpdateBtnClickAction = new Subject<any>();
const passBtnClickAction = new Subject<any>();

const getAudioMediaAction = passAudioMediaAction.asObservable();
const getEMSAudioMediaAction = passEMSAudioMediaAction.asObservable();
const getVideoMediaAction = passVideoMediaAction.asObservable();
const getEMSVideoMediaAction = passEMSVideoMediaAction.asObservable();
const getImageMediaAction = passImageMediaAction.asObservable();
const getEMSImageMediaAction = passEMSImageMediaAction.asObservable();
const getReplyMediaAction = passReplyMediaAction.asObservable();
const getEKGMediaAction = passEKGMediaAction.asObservable();
const getForwardMediaAction = passForwardMediaAction.asObservable();
const getUnAuthorizedAction = passUnAuthorizedAction.asObservable();
const getOnCallResultAction = passOnCallResultAction.asObservable();
const getProfileUpdatedAction = passProfileUpdatedAction.asObservable();
const getUpdateCaseDetails = updateCaseDetails.asObservable();
const getSchedules = passToGetSchedules.asObservable();
const getCalendarDateClick = passCalendarDateClick.asObservable();
const getCalendarDateClear = passCalendarDateClear.asObservable();
const getNotesListAction = passNotesListAction.asObservable();
const getReminderListAction = passReminderListAction.asObservable();
const getProviderListAction = passProviderListAction.asObservable();
const getSmsListAction = passSmsListAction.asObservable();
const getUpdateBtnClickAction = passUpdateBtnClickAction.asObservable();
const getBtnClickAction = passBtnClickAction.asObservable();

const transferAudioMediaAction = (action: any) => {
  passAudioMediaAction.next(action);
};

const transferEMSAudioMediaAction = (action: any) => {
  passEMSAudioMediaAction.next(action);
};

const transferVideoMediaAction = (action: any) => {
  passVideoMediaAction.next(action);
};

const transferEMSVideoMediaAction = (action: any) => {
  passEMSVideoMediaAction.next(action);
};

const transferImageMediaAction = (action: any) => {
  passImageMediaAction.next(action);
};

const transferEMSImageMediaAction = (action: any) => {
  passEMSImageMediaAction.next(action);
};

const transferReplyMediaAction = (action: any) => {
  passReplyMediaAction.next(action);
};

const transferEKGMediaAction = (action: any) => {
  passEKGMediaAction.next(action);
};

const transferForwardMediaAction = (action: any) => {
  passForwardMediaAction.next(action);
};

const transferUnAuthorizedAction = (action: any) => {
  passUnAuthorizedAction.next(action);
};

const transferOnCallResultAction = (action: any) => {
  passOnCallResultAction.next(action);
};

const transferProfileUpdatedAction = (action: any) => {
  passProfileUpdatedAction.next(action);
};

const caseHistoryUpdatedAction = (action: any) => {
  updateCaseDetails.next(action);
};

const transferToGetSchedules = (action: any) => {
  passToGetSchedules.next(action);
};

const transferCalendarDateClick = () => {
  passCalendarDateClick.next();
};

const transferToClearDateSelection = () => {
  passCalendarDateClear.next();
};

const transferNotesListAction = (action: any) => {
  passNotesListAction.next(action);
};

const transferReminderListAction = (action: any) => {
  passReminderListAction.next(action);
};

const transferProviderListAction = (action: any) => {
  passProviderListAction.next(action);
};

const transferSmsListAction = (action: any) => {
  passSmsListAction.next(action);
};

const transferUpdateBtnClickAction = (action: any) => {
  passUpdateBtnClickAction.next(action);
};

const transferBtnClickAction = (action: any) => {
  passBtnClickAction.next(action);
};

export const dataTransferService = {
  getAudioMediaAction,
  getEMSAudioMediaAction,
  getVideoMediaAction,
  getEMSVideoMediaAction,
  getImageMediaAction,
  getEMSImageMediaAction,
  getReplyMediaAction,
  getEKGMediaAction,
  getForwardMediaAction,
  getUnAuthorizedAction,
  getOnCallResultAction,
  getProfileUpdatedAction,
  getUpdateCaseDetails,
  getSchedules,
  getCalendarDateClick,
  getCalendarDateClear,
  getNotesListAction,
  getReminderListAction,
  getProviderListAction,
  getSmsListAction,
  getUpdateBtnClickAction,
  getBtnClickAction,
  transferAudioMediaAction,
  transferEMSAudioMediaAction,
  transferVideoMediaAction,
  transferEMSVideoMediaAction,
  transferImageMediaAction,
  transferEMSImageMediaAction,
  transferForwardMediaAction,
  transferEKGMediaAction,
  transferReplyMediaAction,
  transferUnAuthorizedAction,
  transferOnCallResultAction,
  transferToGetSchedules,
  transferCalendarDateClick,
  transferToClearDateSelection,
  transferProfileUpdatedAction,
  caseHistoryUpdatedAction,
  transferNotesListAction,
  transferReminderListAction,
  transferProviderListAction,
  transferSmsListAction,
  transferUpdateBtnClickAction,
  transferBtnClickAction,
};
